import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";

export interface AppState {
  loading: boolean;
  mode: string;
  snackbar: boolean;
  snackbaralert: boolean;
  notice: string;
  noticealert: string;
  // panduan
  panduanDrawer: boolean;
}

const SUCCESS = "success";
const ERROR = "error";

@Module({ store, dynamic: true, name: "appModule" })
class AppModule extends VuexModule implements AppState {
  public loading = true;
  public mode = "";
  public snackbar = false;
  public snackbaralert = false;
  public notice = "";
  public noticealert = "";
  public alertMessage = "";
  public alertMode = "";
  public msgTtd = "";
  public alert = false;
  public panduanDrawer = false;

  @Action closeNotice(): void {
    this.setNotice("");
    this.setMode("");
    this.setSnackbar(false);
  }

  @Action closeNoticeWithDelay(timeout = 2000): void {
    setTimeout(() => {
      this.setNotice("");
      this.setMode("");
      this.setSnackbar(false);
    }, timeout);
  }

  @Action NoticeDelay(notice: string): void {
    this.setNotice(notice);
    this.setSnackbar(true);
    setTimeout(() => {
      // this.setMode("");
      this.setSnackbar(false);
    }, 2000);
  }

  @Action NoticeDelayAlert(noticealert: string): void {
    this.setNoticealert(noticealert);
    this.setSnackbaralert(true);
    setTimeout(() => {
      // this.setMode("");
      this.setSnackbaralert(false);
    }, 4000);
  }

  @Action sendSuccessNotice(notice: string): void {
    this.setNotice(notice);
    this.setMode(SUCCESS);
    this.setSnackbar(true);
    this.closeNoticeWithDelay();
  }

  @Action sendErrorNotice(notice: string): void {
    this.setNotice(notice);
    this.setMode(ERROR);
    this.setSnackbar(true);
    this.closeNoticeWithDelay();
  }

  @Action sendErrorAlert(message: string): void {
    this.setAlertMessage(message);
    this.setAlertMode(ERROR);
    this.showAlert(true);
  }

  @Action closeErrorAlert(): void {
    this.setAlertMessage("");
    this.showAlert(false);
  }
  @Action sendLoading(): void {
    this.setLoading(true);
  }
  @Action endLoading(): void {
    this.setLoading(false);
  }
  @Action addMsgTtd(message: string) {
    this.setMsgTtd(message);
  }

  //panduan
  @Action setPanduanDrawer(val: boolean): void {
    this.SET_PANDUAN_DRAWER(val);
  }
  @Action togglePanduanDrawer(): void {
    this.SET_PANDUAN_DRAWER(!this.panduanDrawer);
  }
  @Mutation SET_PANDUAN_DRAWER(val: boolean): void {
    this.panduanDrawer = val;
  }
  @Mutation setAlertMessage(message: string): void {
    this.alertMessage = message;
  }

  @Mutation setAlertMode(mode: string): void {
    this.alertMode = mode;
  }

  @Mutation showAlert(show: boolean): void {
    this.alert = show;
  }

  @Mutation setLoading(loading: boolean): void {
    this.loading = loading;
  }

  @Mutation setNotice(notice: string): void {
    this.notice = notice;
  }

  @Mutation setNoticealert(noticealert: string): void {
    this.noticealert = noticealert;
  }

  @Mutation setSnackbar(snackbar: boolean): void {
    this.snackbar = snackbar;
  }

  @Mutation setSnackbaralert(snackbaralert: boolean): void {
    this.snackbaralert = snackbaralert;
  }

  @Mutation setMode(mode: string): void {
    this.mode = mode;
  }
  @Mutation setMsgTtd(msgTtd: string): void {
    this.msgTtd = msgTtd;
  }
}

export const appModule = getModule(AppModule); // Apps;
